module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column start-centered testemunha-container"
  }, [_c('div', [_vm._v("Indique 2 (duas) testemunhas para assinatura da minuta para formalização do projeto:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(!this.editando && !this.gravando) ? _c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "tooltip": "Adiciona uma Testemunha",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleEdicao(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Nova testemunha")]) : _vm._e()]), _vm._v(" "), (!this.editando && !this.gravando) ? _c('b-container', {
    staticClass: "column centered-start w-100 gap-10",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('g-button-ujarak', {
          directives: [{
            name: "confirm",
            rawName: "v-confirm",
            value: ({
              ok: function (retorno) { return _vm.excluirItem(row.item, row.index); },
              cancel: _vm.doNothing,
              message: 'Confirma Exclusão da Testemunha?'
            }),
            expression: "{ok: retorno => excluirItem(row.item, row.index), cancel: doNothing,\n                            message: 'Confirma Exclusão da Testemunha?'}"
          }],
          attrs: {
            "color": "error"
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")])]
      }
    }], null, false, 1969790413)
  })], 1) : _vm._e(), _vm._v(" "), (this.editando && !this.gravando) ? _c('div', {
    staticClass: "column start-centered testemunha-cadastro-container"
  }, [_c('b', [_vm._v("Cadastro de Testemunha")]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start testemunha-form"
  }, [_c('label', {
    staticClass: "control-label testemunha-label f-required",
    attrs: {
      "for": "título do curso"
    }
  }, [_vm._v("Nome:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testemunhaEdicao.nome),
      expression: "testemunhaEdicao.nome"
    }],
    staticClass: "form-control testemunha-input",
    attrs: {
      "name": "título do curso",
      "type": "text"
    },
    domProps: {
      "value": (_vm.testemunhaEdicao.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.testemunhaEdicao, "nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start testemunha-form"
  }, [_c('label', {
    staticClass: "control-label testemunha-label f-required",
    attrs: {
      "for": "título do curso"
    }
  }, [_vm._v("CPF:")]), _vm._v(" "), _c('the-mask', {
    staticClass: "form-control testemunha-input",
    class: _vm.cpfInvalido ? 'campo-invalido' : '',
    attrs: {
      "name": "título do curso",
      "type": "text",
      "mask": '###.###.###-##'
    },
    on: {
      "input": function($event) {
        return _vm.validaCPF()
      }
    },
    model: {
      value: (_vm.testemunhaEdicao.cpf),
      callback: function($$v) {
        _vm.$set(_vm.testemunhaEdicao, "cpf", $$v)
      },
      expression: "testemunhaEdicao.cpf"
    }
  }), _vm._v(" "), (_vm.cpfInvalido) ? _c('span', {
    staticClass: "span-invalido"
  }, [_vm._v("CPF inválido.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start testemunha-form"
  }, [_c('label', {
    staticClass: "control-label testemunha-label f-required",
    attrs: {
      "for": "título do curso"
    }
  }, [_vm._v("E-mail:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testemunhaEdicao.email),
      expression: "testemunhaEdicao.email"
    }],
    staticClass: "form-control testemunha-input",
    class: _vm.emailInvalido ? 'campo-invalido' : '',
    attrs: {
      "name": "título do curso",
      "type": "text"
    },
    domProps: {
      "value": (_vm.testemunhaEdicao.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.testemunhaEdicao, "email", $event.target.value)
      }, function($event) {
        return _vm.validaEmail()
      }]
    }
  }), _vm._v(" "), (_vm.emailInvalido) ? _c('span', {
    staticClass: "span-invalido"
  }, [_vm._v("EMAIL inválido.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row centered-start testemunha-botao"
  }, [_c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "tooltip": "Adiciona uma Testemunha",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.adicionarTestemunha()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Adicionar Testemunha")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-flat",
    attrs: {
      "tooltip": "Cancela Procedimento",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleEdicao(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar ")])])]) : _vm._e(), _vm._v(" "), (this.gravando) ? _c('div', {
    staticClass: "column all-centered testemunha-cadastro-container"
  }, [_vm._v("\n        Gravando... "), _c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-303a8f74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/testemunhas.vue
// module id = 1816
// module chunks = 2